import React from "react";
import { useTranslation } from "react-i18next";
import { Paper, Stack, Typography, useTheme } from "@mui/material";

import { Usage, UsageCategoryKey, UsageMetric } from "../types/Usage";
import AbbreviateNumber from "components/formatting/AbbreviateNumber";
import ISONumber from "components/formatting/ISONumber";

interface UsageCardProps {
  metric: UsageMetric;
  usage: Usage;
  usageCategoryKey: UsageCategoryKey;
}

export default function UsageCard(props: UsageCardProps): React.JSX.Element {
  const { i18n } = useTranslation();
  const theme = useTheme();

  const isShowingPrice = props.metric === "price";

  let formatParams = {};
  if (isShowingPrice) {
    formatParams = {
      currency: props.usage.currency,
      style: "currency"
    };
  }

  const value = props.usage.total[props.metric][props.usageCategoryKey] || 0;
  
  let label = "";
  if (props.metric === "cost") {
    label = i18n.t(`usage.units.${props.usageCategoryKey}`);
  } else if (props.metric === "count") {
    label = i18n.t("usage.units.completed-requests");
  }

  return (
    <Paper style={{opacity: value > 0 ? 1 :  0.5}}>
      <Stack
        sx={{
          alignItems: "center",
          p: 1,
          width: 200
        }}>
        <Typography variant="h4">{i18n.t(`usage.categories.${props.usageCategoryKey}`)}</Typography>
        {props.metric === "price" &&
          <ISONumber number={value} options={formatParams} sx={{color: theme.colors.primary.main, display: "block", height: undefined, textAlign: "center"}} typographyVariant="h3" />
        }
        {props.metric !== "price" &&
          <AbbreviateNumber hideTooltip={value === 0} options={formatParams} sx={{color: theme.colors.primary.main, display: "block", height: undefined, textAlign: "center"}} typographyVariant="h3" value={value} />
        }
        <Typography variant="subtitle2">{label}</Typography>
      </Stack>
    </Paper>
  );
}